export const TRANSLATIONS_FR_CA = {
  labels: {
    show_map: "Afficher la carte",
    submission_guideline: "Ligne directrice de soumission",
    delete_custom_documents: "Supprimer les documents personnalisés",
    search_by_foundation_name: "Rechercher par nom de fondation…",
    explore_funding: "Explorez les opportunités de financement partout au Canada !",
    explore_funding_ca: "Explorez les opportunités de financement partout au Canada !",
    watch_demo_slides: "Regarder les diapositives de démonstration",
    join_live_webinar: "Participez à un webinaire de questions-réponses en direct",
    register_webinar: "S'inscrire au webinaire en direct",
    roadmap_success_guide: "Guide du plan de réussite",
    charities_helping_charities_title: "Programme de parrainage : organismes aidant les organismes",
    you_got_funded: "Votre demande a été financée. Réclamez votre bonus.",
    report_your_successful_grant: "Signalez l'obtention de votre subvention et débloquez instantanément 25 $ de crédits d'avance sur subvention.",
    refer_charity_earn_bonus: "Parrainez un organisme et gagnez du temps supplémentaire !",
    optimal_browser_use: "Utilisation optimale du navigateur",
    browser_recommendation: "Pour une meilleure expérience, nous recommandons d'utiliser les dernières versions de Chrome ou Firefox.",
    roadmap_success_pdf: "Plan de réussite.pdf",
    charities_program_form: "Formulaire du programme d'organismes aidant les organismes.pdf",
    refer_a_charity: "Parrainer un organisme",
    user_name: "Nom d'utilisateur",
    password: "Mot de passe",
    reset_password: "Nouveau mot de passe",
    reset_password_confirm: "Confirmez le mot de passe",
    login: "Connexion",
    sign_up: "S'inscrire",
    forgot_password: "Mot de passe oublié ?",
    go_back: "Retourner",
    organization: "Organisation",
    phone: "Téléphone",
    first_name: "Prénom",
    last_name: "Nom de famille",
    address: "Adresse",
    select: "Sélectionner",
    country: "Pays",
    complementary_address: "Adresse complémentaire",
    postal_code: "Code postal",
    city: "Ville",
    state: "État",
    stateOrProvince: "État/Province",
    billing: "Facturation",
    use_same_address: "Utiliser la même adresse",
    loading: "Chargement...",
    register: "S'inscrire",
    message: "Message",
    error: "Erreur",
    welcome_back: "Bonjour, bon retour",
    enter_credentials: "Entrez vos identifiants pour continuer",
    dont_have_account: "Vous n'avez pas de compte ?",
    remember_me: "Se souvenir de moi",
    sign_in: "Se connecter",
    already_have_account: "Vous avez déjà un compte ?",
    subscription_plan: "Formule d'abonnement",
    country_billing: "Facturation par pays",
    password_recovery: "Récupération de mot de passe",
    password_reset: "Réinitialisation du mot de passe",
    setting_up_account: "Configuration du compte",
    current_password: "Mot de passe actuel",
    new_password: "Nouveau mot de passe",
    confirm_password: "Confirmez le mot de passe",
    confirming_account: "Confirmation du compte",
    accounts_created: "Comptes créés",
    of: "de",
    or: "OU",
    search: "Rechercher",
    clear: "Effacer",
    status: "Statut",
    actions: "Actions",
    add_new_user: "Ajouter un nouvel utilisateur",
    edit_user: "Modifier l'utilisateur",
    additional_emails: "Courriels supplémentaires",
    organization_letterhead: "Papier à en-tête de l'organisation",
    similar_charities: "Organismes similaires",
    similar_charities_description: "Recherchez des organismes de bienfaisance similaires au vôtre afin que nous puissions trouver des bailleurs de fonds qui soutiennent votre région.",
    similar_charities_search_label: "Rechercher des organismes",
    similar_charities_search_placeholder: "Saisissez le nom d'un organisme...",
    similar_charities_manual_entry_hint: "Vous ne le trouvez pas dans la liste? Saisissez le nom complet et appuyez sur Entrée pour l'ajouter manuellement.",
    similar_charities_selected_count: "{{count}} sélectionné(s)",
    similar_charities_no_results: "Aucun organisme trouvé",
    similar_charities_saved: "Organismes similaires enregistrés avec succès",
    add_similar_charities: "Ajouter des Organismes Similaires",
    company_information: "Informations sur l'organisation",
    company_organization: "Organisation",
    created_at: "Créé le",
    added_by: "Ajouté par",
    change_main_email: "Modifier l'adresse courriel principale",
    main_email: "Adresse courriel principale",
    emails_created: "Courriels créés",
    add_new_additional_email: "Ajouter un nouveau courriel supplémentaire",
    new_email_address: "Nouvelle adresse courriel",
    add_digital_letterhead: "Ajouter un en-tête numérique",
    select_header_style: "Sélectionnez le style de lettre",
    header_only: "En-tête uniquement",
    header_and_footer: "En-tête et pied de page",
    exclude_pre_loaded: "Exclure les éléments préchargés",
    email_alert: "Alerte courriel",
    signature: "Signature",
    user_letterhead: "En-tête de l'utilisateur",
    user_information: "Informations de l'utilisateur",
    position: "Poste",
    enable_disable_notifications: "Activer / Désactiver les notifications",
    user_name_or_email: "Nom d'utilisateur ou courriel",
    avg_grants_Annually: "Subventions moyennes annuelles",
    avg_grant_size: "Taille moyenne de la subvention",
    total_assets: "Total des actifs",
    summary: "Résumé",
    notes_taken: "Notes prises",
    last_report: "Dernier rapport",
    not_informed: "Non renseigné",
    loading_profile_summary: "Chargement du résumé du profil",
    amount: "Montant",
    grants: "Subventions",
    funders: "Bailleurs de fonds",
    funders_selected: "Bailleurs de fonds sélectionnés",
    show_grant_details: "Afficher les détails de la subvention",
    profile_summary: "Résumé du profil",
    view_profile: "Voir le profil",
    year: "Année",
    avg_grants: "Subventions moyennes",
    recipient: "Bénéficiaire",
    territories: "Territoires",
    giving_int: {
      prefix: "Intérêt national de don pour",
      state: "État",
      province: "Province",
      territories: "Territoires",
    },
    foundation_name: "Nom de la fondation",
    import: "Importer",
    organization_name: "Nom de l'organisation",
    contact_name: "Nom du contact",
    state_or_province: "État / Province",
    info: "Info",
    add_funders_to_project: "Ajouter des bailleurs de fonds au projet",
    add_funder_to_project: "Ajouter un bailleur de fonds au projet",
    export_to_excel: "Exporter vers Excel",
    block_funders: "Bloquer les bailleurs de fonds",
    province: "Province",
    databases: "Bases de données",
    search_result: "Résultat de la recherche",
    back_to_search: "Retour à la recherche",
    location: "Emplacement",
    purpose: "Objectif",
    category: "Catégorie",
    sector: "Secteur",
    sectors: "Secteurs",
    not_provided_by: "Non fourni par",
    keyword: "Mot-clé",
    my_list: "Ma liste",
    shared_list: "Liste partagée",
    favorite_name: "Nom du favori",
    select_favorite: "Sélectionnez un favori",
    close: "Fermer",
    confirm: "Confirmer",
    description: "Description",
    show_saved_search: "Afficher la recherche enregistrée",
    save_regional_search: "Enregistrer la recherche régionale",
    save_search: "Enregistrer la recherche",
    switch_to_classic: "Passer à la version classique",
    load_selected_saved_search: "Charger la recherche enregistrée sélectionnée",
    rename: "Renommer",
    remove_save_search: "Supprimer la recherche enregistrée",
    updated_at: "Mis à jour le",
    amt: "Montant",
    create_user_account: "Créer un projet utilisateur",
    edit_user_account: "Modifier un projet utilisateur",
    name_project: "Nom du projet",
    total_project_cost: "Coût total du projet",
    start_date: "Date de début",
    end_date: "Date de fin",
    delete_project: "Supprimer le projet",
    select_director_from_list: "Sélectionnez un directeur dans la liste",
    enter_custom_director: "Directeur introuvable ? Ajoutez-en un personnalisé",
    enter_director_name: "Entrez le nom du directeur",
    select_director: "Sélectionner un directeur",
    salutation: "Salutation",
    ask_amount: "Montant demandé",
    total_amount: "Montant total",
    application_information: "Informations sur la demande",
    instruction: "Instructions",
    restriction: "Restrictions",
    deadline: "Date limite",
    contact: "Contact",
    largest: "Le plus grand",
    average: "Moyenne",
    median: "Médiane",
    remove_funder: "Supprimer les bailleurs de fonds",
    foundation_exists_other_projects: "Ce bailleur de fonds existe dans d'autres projets au sein de votre organisation",
    remove_foundations_other_projects: "Supprimer les bailleurs de fonds d'autres projets",
    application_info: "Informations sur la demande",
    this_action_will_remove: "Cette action supprimera",
    from_this_project: "de ce projet",
    hide_customized_funders: "Masquer les bailleurs de fonds personnalisés",
    project_funders: "Bailleurs de fonds du projet",
    custom_letter: "Lettre personnalisée",
    change_project: "Changer le projet",
    return_grant_secretary: "Retourner au secrétariat des subventions",
    impact_report_letter: "Lettre de rapport d'impact",
    project_funders_master_document: "Bailleurs de fonds du projet / Document principal",
    master_document: "Document principal",
    letter_of_inquiry: "Lettre de demande",
    proposal: "Proposition",
    thank_you_letter: "Lettre de remerciement",
    custom_document: "Document personnalisé",
    qualify: "Qualifier",
    favorites: "Favoris",
    favorite_funders: "Bailleurs de fonds favoris",
    select_one_or_more_projects: "Sélectionnez un ou plusieurs projets",
    print_funder_page: "Imprimer la page du bailleur de fonds",
    move_to_previous_funder: "Passer au bailleur de fonds précédent",
    move_to_next_funder: "Passer au bailleur de fonds suivant",
    remove_this_funder_from_qualified: "Supprimer ce bailleur de fonds du statut qualifié et l'exclure de la liste des favoris.",
    mark_funder_as_qualified: "Marquer ce bailleur de fonds comme qualifié.",
    block_funder: "Bloquer le bailleur de fonds",
    export_funders_to_excel: "Exporter les bailleurs de fonds vers Excel",
    funder_name: "Nom du bailleur de fonds",
    prev: "Précéd.",
    next: "Suivant",
    previous: "Précédent",
    visit_website: "Visiter le site web",
    notes: "Notes",
    add_note: "Ajouter une note",
    company: "Entreprise",
    email: "Courriel",
    website: "Site web",
    contact_infos: "Informations de contact",
    other_infos: "Autres informations",
    help_center: "Centre d'aide",
    profile_settings: "Paramètres du profil",
    hi: "Bonjour",
    user_profile: "Profil utilisateur",
    logout: "Déconnexion",
    causes: "Causes",
    location_of_donations: "Emplacement des dons",
    reset_funder_qualification_status: "Réinitialiser le statut de qualification d'un bailleur de fonds",
    pause_qualification: "Qualification en pause",
    pause_qualification_process: "Mettre le processus de qualification en pause sans finaliser la décision.",
    reset_funder: "Réinitialiser le bailleur de fonds",
    qualified: "Qualifié",
    paused_qualification: "Qualification en pause",
    unqualified: "Non qualifié",
    return_to_gs_from: "Retour à Grant Secretary depuis {{docType}}",
    referral: "Parrainez un organisme de bienfaisance et gagnez du temps bonus !",
    referralFormPopup: "Parrainez un ami pour gagner du temps d'abonnement",
    referralShareFormPopup: "Partagez votre lien de parrainage pour gagner du temps d'abonnement",
    referral_code_tooltip: "Cliquez pour copier le code de parrainage",
    phone_number: "Numéro de téléphone",
    email_address: "Courriel",
    charity_name: "Nom de l'organisme de bienfaisance",
    contact_name: "Nom du contact",
    referral_popup_title: "Parrainez un ami",
    flagged_donor_advised: "Marqué comme fonds conseillé par le donateur",
    DAF: "FAD",
    referral_code: "Code de parrainage",
    report_grant: "Déclarer une subvention",
    name_of_contact: "Nom du contact",
    grant_amount: "Montant de la subvention",
    date_awarded: "Date d'attribution",
    earn_bonus_time: "GAGNEZ DU TEMPS BONUS !",
    additional_information: "Informations supplémentaires",
    categories: "Catégories",
    populations_served: "Populations desservies",
    mission: "Mission",
    geographic_areas_served: "Zones géographiques desservies",
    org_profile: "Profil org.",
    un_sdg_goals: "Objectifs ODD de l'ONU",
    social_media: "Réseaux sociaux",
    select_goals: "Sélectionner des objectifs",
    no_goals_selected: "Aucun objectif sélectionné",
    select_social_media: "Sélectionner les réseaux sociaux",
    mission_placeholder: "De quoi parle votre organisation ? Partagez brièvement ici votre objectif principal ou votre mission fondamentale !",
    emails: "Courriels",
    add_email: "Ajouter un courriel",
    enter_new_email: "Entrez une nouvelle adresse courriel",
    adding_new_email: "Ajout d'un nouveau courriel",
    target_beneficiaries: "Bénéficiaires cibles",
    measurable_outcomes: "Résultats mesurables",
    type_keyword_and_press_enter: "Saisissez un mot-clé et appuyez sur Entrée pour ajouter une balise",
    tags: "Balises",
    project_name_and_description: "Nom et description du projet",
    project_date_and_cost: "Date et coût du projet",
    grant_advance_ai: "Grant Advance A.I",
    create_new_project: "Créer un nouveau projet",
    edit_project: "Modifier le projet",
    other_information: "Autres informations",
    header_and_footer_settings: "Paramètres d'en-tête / pied de page",
    exclude_header_footer: "Exclure l'en-tête et le pied de page de l'organisation",
    exclude_header_footer_desc: "Lorsque cette option est cochée, l'en-tête et le pied de page du profil de l'organisation ne seront pas chargés dans l'aperçu du document. C'est idéal si l'en-tête et le pied de page sont déjà inclus directement dans votre papier à en-tête ou votre document principal.",
    settings_saved_successfully: "Paramètres enregistrés avec succès",
    add_header_footer: "Cela appliquera l'en-tête et le pied de page que vous avez téléchargés dans les paramètres de votre compte en haut et en bas de la première page de votre document.",
    do_not_add_header_footer: "Aucun en-tête ni pied de page ne sera ajouté à votre document. Nous recommandons cette option si vous imprimez vos documents sur du papier à en-tête pré-marqué ou déjà personnalisé.",
    account_registration: "Inscription au compte",
    organization_info: "Informations sur l'organisation",
    billing_info: "Informations de facturation",
    plan_selection: "Sélection du forfait",
    payment_info: "Informations de paiement",
    add_user_info: "Ajoutez vos informations utilisateur",
    add_organization_info: "Ajoutez les informations de votre organisation",
    add_billing_info: "Ajoutez vos informations de facturation",
    select_plan: "Sélectionnez un forfait pour votre compte",
    add_payment_info: "Ajoutez vos informations de paiement",
    organization_address: "Adresse de l'organisation",
    address_line_2: "Adresse ligne 2",
    postal: "Code postal",
    zip: "Code ZIP",
    same_billing_address: "Votre adresse de facturation est-elle la même que celle de votre organisation ?",
    billing_address: "Adresse de facturation",
    select_payment: "Sélectionnez votre type de paiement",
    organization_name: "Nom de l'organisation",
    province: "Province",
    assets: "Actifs",
    revenue: "Revenus",
    donations: "Dons",
    create_new_project_to_get_started: "Créez un nouveau projet pour commencer",
    be_sure_create_project_dg: "Assurez-vous de créer un projet avant d'utiliser le Générateur de documents.",
    remove_duplicate_funders: "Supprimer les bailleurs de fonds en double",
    remove_funders_present_in_other_projects: "Supprimer de ce projet les bailleurs de fonds présents dans d'autres projets",
    bulk_flag_update: "Mise à jour massive des indicateurs",
    print_return_labels: "Imprimer les étiquettes de retour",
    print_labels: "Imprimer les étiquettes",
    labels: "Étiquettes",
    print_selected: "Imprimer {{text}}",
    preview_selected: "Aperçu des documents {{text}}",
    export_all_pdf_words_selected: "Exporter tous les {{text}} (PDF, Word)",
    documents: "Documents",
    remove_from_this_project: "Retirer de ce projet",
    notifications: "Notifications",
    feedback: "Commentaires",
    giving_history: "Historique des dons",
    name: "Nom",
    director: "Directeur",
    custom: "Personnalisé",
    international_funding: "Financement international",
    director_name: "Nom du directeur",
    from_country: "Du pays",
    to_country: "Vers le pays",
    county: "Comté",
    sub_sector: "Sous-secteur",
    national_giving_interest: "Intérêt national pour les dons",
    min_grants_to_state: "Dons à l'État",
    min_grants_to_state_any: "Nombre de dons indifférent",
    years: "Années",
    filter: "Filtrer",
    geographic_filters: "Filtres géographiques",
    grant_filters: "Filtres de subventions",
    grant_size: "Taille de la subvention",
    asset_size: "Taille des actifs",
    year_of_donation: "Année de don",
    keywords: "Mots-clés",
    any_of_these_words: "N'importe lequel de ces mots",
    all_these_words: "Tous ces mots",
    none_of_these_words: "Aucun de ces mots",
    stemming: "Racinisation",
    thesaurus: "Thésaurus",
    cross_reference_search: "Recherche par référence croisée",
    add_cross_reference_search: "Ajouter une recherche par référence croisée",
    state_filter: "Filtre par État",
    province_filter: "Filtre par province",
    county_filter: "Filtre par comté",
    city_filter: "Filtre par ville",
    funder_characteristics: "Caractéristiques du bailleur de fonds",
    has_online_application: "A une demande en ligne",
    does_not_have_website: "N'a pas de site web",
    does_have_website: "A un site web",
    has_submission_guidelines: "Has Submission Guidelines",
    has_phone_number: "A un numéro de téléphone",
    has_email: "A un courriel",
    show_designated_giving: "Afficher les dons désignés",
    show_funders_without_donations: "Afficher les bailleurs sans dons",
    show_more: "Afficher plus",
    search_history: "Historique des recherches",
    last_modified_on: "Dernière modification le",
    saved_searches: "Recherches enregistrées",
    saved_search: "Recherche enregistrée",
    saved_regional_search: "Recherche régionale enregistrée",
    history: "Historique",
    created_by: "Créé par",
    choose_years: "Choisir les années",
    databases: "Bases de données",
    cross_ref_on: "Référence croisée activée",
    search_summary_all: "Résumé de la recherche pour tous",
    active_filters: "Filtres actifs",
    group_by_funder: "Grouper par bailleur de fonds",
    grant_summary: "Résumé des subventions",
    median_grant: "Subvention médiane",
    average_grant: "Subvention moyenne",
    view_saved_search: "Voir la recherche enregistrée",
    state_or_province: "État / Province",
    manage_coupons: "Gérer les coupons",
    create_new_coupon: "Créer un nouveau coupon",
    recipient_name: "Historique des dons",
    grant_purpose: "Objectif de la subvention",
    search_by_recipient_name: "Rechercher par nom du bénéficiaire",
    search_by_grant_purpose: "Rechercher par objectif de la subvention",
    search_by_funder_name: "Rechercher par nom du bailleur de fonds",
    type: "Type",
    discount: "Rabais",
    tax: "Taxe",
    extra_time: "Temps supplémentaire",
    expires_on: "Expire le",
    email_login: "Courriel de connexion",
    reenter_password: "Ressaisir le mot de passe",
    no_plan_selected: "Aucun forfait sélectionné",
    subscription_summary: "Résumé de l'abonnement",
    business_number: "Numéro d'entreprise",
    title: "Titre",
    createdDate: "Date de création",
    createdBy: "Créé par",
    notified: "Notifié",
    notification: "Notification",
    emailNotificationDate: "Date de notification par courriel",
    editNote: "Modifier la note",
    removeNote: "Supprimer la note",
    editAlert: "Modifier l'alerte",
    removeAlert: "Supprimer l'alerte",
    updateAlert: "Mettre à jour l'alerte",
    enterTitle: "Entrez le titre",
    selectEmail: "Sélectionnez un courriel",
    notes_by: "Notes de",
    selectStatusFlag: "Sélectionner le statut du drapeau",
    documentType: "Type de document",
    flagStatus: "Statut du drapeau",
    submissionMethod: "Méthode de soumission",
    flagDate: "Date du drapeau",
    remove: "Supprimer",
    funderStatus: "Statut du bailleur de fonds",
    create_project: "Créer un projet",
    remove_project: "Supprimer le projet",
    unarchive: "Désarchiver",
    archive_project: "Archiver le projet",
    mark_project_as_completed: "Marquer le projet comme terminé",
    activate_project: "Activer le projet",
    activate_project_button: "Activer le projet",
    no_projects_yet_heading: "Vous n'avez pas encore de projets",
    search_manually: "Rechercher manuellement",
    start_qualifying_funders: "Commencer à qualifier",
    continue_qualifying_funders: "Continuer à qualifier",
    view_funders: "Voir les bailleurs de fonds",
    add_funders_to_project: "Ajouter des bailleurs de fonds à ce projet",
    keep_looking_for_funders: "Continuer à chercher des bailleurs de fonds",
    use_your_peer_network: "Utilisez votre réseau d’organismes similaires",
    peer_search: "Recherche entre pairs",
    run_peer_search: "Lancer la recherche entre pairs",
    about_qualifying_funders: "À propos de la qualification des bailleurs de fonds",
    about_peer_search: "À propos de la recherche entre pairs",
    project_overview_title: "Aperçu de {{name}}",
    project_name: "Nom du projet",
    shared_by: "Partagé par",
    project_status: "Statut du projet",
    notified_at: "Notifié le",
    notify_at: "Notifier le",
    updating_notes: "Mise à jour des notes",
    attached_documents: "Documents joints",
    alert_notification: "Notification d’alerte",
    notification_sent: "Notification envoyée",
    notification_by_email: "Notification par courriel",
    attach_documents: "Joindre des documents",
    loading_attached_documents: "Chargement des documents joints",
    search_by_year_searchbar_title: "Par année de création",
    search_by_name_searchbar_title: "Par nom du bailleur de fonds",
    search_by_director_searchbar_title: "Par les administrateurs",
    search_by_custom_searchbar_title: "Par contacts privés",
    search_by_keyword_searchbar_title: "En donnant des intérêts",
    create_coupon: "Créer un coupon",
    update_coupon: "Mettre à jour le coupon",
    code: "Code",
    expiration_date: "Date d’expiration",
    toggle_to_extra_time: "Activer le temps supplémentaire",
    toggle_to_discount: "Activer le rabais",
    extra_month: "Mois supplémentaire",
    discount_percentage: "Pourcentage de rabais",
    coupon_default_flag: "Indicateur par défaut du coupon",
    unlock_plans: "Déverrouiller les forfaits",
    template_coupon: "Modèles de coupons",
    search_by_giving_history_searchbar_title: "By Giving History",
    demo_access_link: "Lien d’accès à la démo",
    signed_in_as: "Connecté en tant que",
    for_sales_use_only: "Réservé à un usage interne",
    your_access_link: "Votre lien d’accès",
    expires_in: "Expire dans",
    link_becomes_invalid: "le lien devient invalide après cela",
    email_reminders: "Rappels par courriel",
    file_attachments: "Pièces jointes",
    add_notification: "Ajouter une notification",
    add_email_notification: "Ajouter une notification par courriel",
    edit_email_notification: "Modifier la notification par courriel",
    select_date: "Sélectionnez une date",
    notifications_found: "Notifications trouvées",
    has_application_description: "A une description de la demande",
    giving_interest: "Intérêt de don",
    board_directors: "Membres du conseil d’administration",
    year_founded: "Année de fondation",
    private_contacts: "Contacts privés",
    switch_to_new: "Passer à la nouvelle version",
    switch_to_legacy: "Passer à l’ancienne version",
    welcome_back_2: "Bon retour",
    email_address_2: "Adresse courriel",
    recently_saved_search: "Recherche enregistrée récemment",
    edit_notification: "Modifier la notification",
    licenses: "Licences",
    registered: "Enregistré",
    status: "Statut",
    role: "Rôle",
    delete: "Supprimer",
    suspend_license: "Suspendre la licence",
    licenses_used: "licences utilisées",
    available: "Disponible",
    new_main_user: "Nouveau utilisateur principal",
    previous_main_user: "Utilisateur principal précédent",
    will_be_downgraded_part: "sera rétrogradé en sous-utilisateur avec le",
    supervisor: "Superviseur",
    main_user: "Utilisateur principal",
    not_applied: "Non appliqué",
    disabled: "Désactivé",
    active: "Actif",
    expired: "Expiré",
    deleted: "Supprimé",
    trial: "Essai",
    trial_expired: "Essai expiré",
    upgrade_demo_account: "Mettre à niveau le compte démo",
    account_email: "E-mail du compte",
    pipedrive: "Pipedrive",
    number_of_licenses: "Nombre de licences",
    payment: "Paiement",
    pay_now: "Payer maintenant",
    paid: "Payé",
    send_payment_link: "Envoyer le lien de paiement",
    skip_payment: "Ignorer le paiement",
    search_by: "Rechercher par",
    no_data_to_display: "Aucune donnée à afficher",
    qualified_funder: "Bailleur de fonds qualifié",
    qualifications: "Qualifications",
    grant_type: "Type de subvention",
    qualified_by: "Qualifié par",
    date_added: "Date d’ajout",
    internal_notes: "Notes internes",
    funder_qualification: "Qualification du bailleur de fonds",
    edit_funder_qualification: "Modifier la qualification du bailleur de fonds",
    qualify_funders: "Qualifier le(s) bailleur(s) de fonds",
    create_add_to_favorite_list: "Créer/Ajouter à la liste des favoris",
    enter_rationale_or_notes: "Saisissez la justification ou les notes",
    delete_qualification: "Supprimer la qualification",
    type_a_sector_name: "Saisissez un nom de secteur",
    this_field_is_empty: "Le champ est vide",
    adding_sector: "Ajout du secteur",
    adding_grant_type: "Ajout du type de subvention",
    choose_grant_type_or_create_one: "Choisissez un type de subvention ou créez-en un",
    other_funding_source: "Autre source de financement",
    statistical_proof: "Preuve statistique",
    do_it_with_grant_advance_ai: "Faites-le avec Grant Advance AI",
    find_matching_funders: "Trouver des bailleurs de fonds compatibles",
    find_funders_with_ai: "Trouver des bailleurs de fonds avec l’IA",
    ai_beta_badge_label: "À propos du statut bêta de l’IA",
    draft_your_letter_of_inquiry: "Rédiger votre lettre d’intérêt",
    write_loi_with_ai: "Rédiger la lettre d’intérêt avec l’IA",
    generate_full_content: "Générer tout le contenu",
    generate_step_content: "Générer avec l’IA",
    regenerate_step_content: "Régénérer avec l’IA",
    reviewed: "Révisé",
    mark_as_reviewed: "Marquer comme révisé",
    change_tone: "Changer le ton",
    change_content_tone: "Changer le ton du contenu",
    save_and_work_on_later: "Enregistrer et continuer plus tard",
    generate_full_content_with_ai: "Générer tout le contenu avec l’IA",
    select_tone: "Sélectionner le ton",
    select_reason: "Sélectionner le motif",
    reason_donation: "Merci pour votre don",
    reason_rejected: "Merci pour votre considération (Refusé)",
    reason_no_reply: "Merci pour votre considération (Sans réponse)",
    reason_other: "Autre",
    other_reason_placeholder: "Décrivez le motif de cette lettre",
    generate: "Générer",
    overwrite_content: "Remplacer le contenu",
    entire_country: "Tout le pays",
    everywhere_within_one_country: "Partout dans un pays",
    specific_area: "Zone spécifique",
    a_region_a_city_or_both: "Une {{orgRegion}}, une ville ou les deux",
    select_a_country: "Sélectionner un pays",
    all_states: "Tous les États",
    all_provinces: "Toutes les provinces",
    all_cities: "Toutes les villes",
    all_counties: "Tous les comtés",
    add_area: "Ajouter une zone",
    add_charity: "Ajouter un organisme de bienfaisance",
    add_statistical_proof: "Ajouter une preuve statistique",
    search_more_suggestions: "Rechercher d’autres suggestions",
    add_your_own_statistical_proof: "Ajouter votre propre preuve statistique",
    statistical_proofs_added: "Preuves statistiques ajoutées",
    view_source: "Voir la source",
    areas_added: "Zones ajoutées",
    go_to_fields: "Aller aux champs",
    add_stat: "Ajouter une statistique",
    generate_suggestions: "Générer des suggestions",
    on: "Activé",
    off: "Désactivé",
    quick_qualification: "Qualification rapide",
    already_qualified: "Déjà qualifié",
    qualifying_preferences_uppercase: "PRÉFÉRENCES DE QUALIFICATION",
    carry_forward_selection: "Conserver la sélection",
    keeps_your_project_picks_selected: "Conserve les sélections de votre projet pour le prochain financeur",
    auto_advance_next_funder: "Passer automatiquement au financeur suivant",
    not_fit: "Non adapté",
    add_to_project: "Ajouter au projet",
    qualify_funder: "Qualifier le bailleur de fonds",
    add_details: "Ajouter des détails",
    add_details_helper_collapsed: "Secteur, type de subvention, notes — facultatif",
    add_details_helper_expanded: "Facultatif",
    pick_a_verdict_to_continue: "Choisissez un verdict pour continuer",
    marked_qualified: "Marqué comme qualifié",
    marked_not_fit: "Marqué comme non adapté",
    select_funder: "Sélectionner le bailleur de fonds",
    previous_funder: "Bailleur de fonds précédent",
    next_funder: "Bailleur de fonds suivant",
    reopen_quick_qualification: "Rouvrir la qualification rapide",
    qualification_verdict: "Verdict de qualification",
    funder_revoked: "Bailleur de fonds révoqué",
    new_donees: "Nouveaux bénéficiaires",
    already_applied: "Déjà soumis",
    view_projects: "Voir les projets",
    coupon_code: "Coupon Code"
  },
  crossReference: {
    any_of_these_words: "N'importe lequel de ces mots",
  },
  filters: {
    no_low_limit: "Pas de limite inférieure",
    no_upper_limit: "Pas de limite supérieure",
  },
  errors: {
    model_error: "Vérifiez les erreurs et réessayez",
    general_error: "Une erreur s'est produite",
    profile_still_loading: "Votre profil est en cours de chargement. Veuillez patienter un instant et réessayer.",
    invalid_token: "Jeton invalide",
    confirming_account_error: "Ce lien a expiré. Souhaitez-vous recevoir un nouveau courriel d'activation ?",
    invalid_image: "Image invalide",
    inform_crop_area: "Redimensionnez l'image pour qu'elle soit conforme aux dimensions requises",
    funder_not_found: "Bailleur de fonds introuvable",
    file_list_error: "Erreur dans la liste des fichiers",
    select_at_least_one_funder: "Veuillez sélectionner au moins un bailleur de fonds avant de continuer",
    select_one_or_more_funders_delete: "Sélectionnez un ou plusieurs bailleurs de fonds à supprimer",
    select_one_or_more_funders_block: "Sélectionnez un ou plusieurs bailleurs de fonds à bloquer",
    this_link_has_expired: "Ce lien a expiré.",
    would_you_like_us_to_send_email: "Souhaitez-vous recevoir un nouveau courriel d'activation/de configuration ?",
    recaptcha_failed: "La vérification de sécurité a échoué. Veuillez réessayer en cliquant sur Suivant.",
    recaptcha_required: "La vérification de sécurité est requise.",
    both_password_must_be_the_same: "Les deux mots de passe doivent être identiques",
    error_creating_token: "Erreur lors de la création du jeton"
  },
  success: {
    logout_success: "Déconnexion réussie",
    copied_to_cliboard: "Copié dans le presse-papiers",
    organization_update: "Les informations de l'organisation ont été mises à jour avec succès",
  },
  messages: {
    jumpstart_journey: "Cher/Chère {userName}, démarrez votre parcours avec ces diapositives informatives pour naviguer sur notre site, trouver des bailleurs de fonds potentiels et rédiger des demandes de subvention.",
    have_questions: "Vous avez des questions ? Rejoignez notre webinaire interactif pour obtenir un support en temps réel. Réservez votre place en cliquant sur le lien ici.",
    follow_guide: "Suivez le guide ci-joint pour des stratégies éprouvées pour sécuriser le financement des subventions.",
    referral_bonus_1: "Lorsque le premier organisme que vous parrainez s'inscrit à Grant Advance, vous recevrez un mois supplémentaire de bonus.",
    referral_bonus_2: "Le deuxième parrainage vous donne deux mois supplémentaires.",
    referral_bonus_3: "Le troisième et chaque parrainage supplémentaire vous donnent trois mois supplémentaires chacun.",
    report_grant_bonus_1: "Licences utilisateur supplémentaires pour votre équipe",
    report_grant_bonus_2: "Services de rédaction de lettres de demande de renseignements",
    report_grant_bonus_3: "Abonnements et renouvellements",
    it_takes_less_than_a_minute: "Cela prend moins d'une minute, et vos crédits vous attendent. Les crédits n'ont aucune valeur monétaire et ne peuvent être cumulés avec d'autres offres.",
    password_recovery_message: "Pour recevoir un nouveau mot de passe, entrez le nom d'utilisateur et l'adresse courriel que vous avez utilisés pour vous inscrire",
    inform_new_password_message: "Veuillez entrer votre nouveau mot de passe",
    setting_up_account_message: "Pour activer votre compte, veuillez entrer le mot de passe et confirmer",
    confirming_account_wait: "Veuillez patienter pendant que nous confirmons votre compte",
    first_letterhead_message: "- L'en-tête doit mesurer environ 700 x 200 px.",
    second_letterhead_message: "- Les formats pris en charge sont .GIF, .png, .jpeg et .jpg.",
    third_letterhead_message: "- L'en-tête de votre organisation apparaîtra en haut de tous les documents.",
    check_organization_settings_message: "Veuillez vérifier les paramètres de l'en-tête du profil de votre organisation ou contacter le support.",
    funders_not_selected_message: "Veuillez sélectionner au moins un bailleur de fonds avant de continuer",
    project_not_selected_message: "Veuillez d'abord créer ou sélectionner un projet",
    you_must_select_state: "Vous devez sélectionner un État pour activer le filtre par ville.",
    deselect_all_counties: "Désélectionnez tous les comtés pour activer le filtre par ville.",
    select_one_favorite_list: "Veuillez sélectionner au moins une liste de favoris ou en créer une nouvelle",
    create_new_favorite_list: "Créer une nouvelle liste de favoris",
    add_funders_favorite_list: "Ajouter des bailleur(s) de fonds aux favoris",
    saved_search_load_successfully: "Recherche enregistrée chargée avec succès",
    save_search: "Enregistrer la recherche",
    delete_project: "Êtes-vous sûr de vouloir supprimer ce projet ?",
    are_you_sure: "Êtes-vous sûr ?",
    this_action_will_remove_document_funder: "Cette action supprimera le document pour ce bailleur de fonds",
    this_action_will_remove_master_document: "Cette action supprimera ce document principal",
    want_to_remove_the_funder: "Voulez-vous retirer le bailleur de fonds de cette liste ?",
    this_will_remove_customized_documents: "Cela supprimera {{documents}} document(s) personnalisé(s) et renverra le bailleur de fonds à la liste principale. Pour supprimer définitivement les bailleurs de fonds, supprimez-les de la liste principale.",
    remove_the_funders_from_the_projects: "Supprime les bailleurs de fonds des projets sélectionnés du projet actuel.",
    select_in_dropdown_example: "Par exemple, si vous sélectionnez un projet dans la liste déroulante et qu'il a 3 bailleurs de fonds, 'a', 'b' et 'c' et que le projet sur lequel vous travaillez a également 'a', 'b', 'c', ceux-ci seront retirés du projet en cours.",
    this_will_remove_funders_from_this_project: "Cette action retirera {{funders}} bailleur(s) de fonds de ce projet.",
    want_reset_this_funder: "Êtes-vous sûr de vouloir réinitialiser ce bailleur de fonds ?",
    do_not_insert_pre_loaded_letterhead_or_footer_document: "N'insérez pas d'en-tête ou de pied de page préchargé à partir de votre profil d'organisation dans les documents générés",
    new_email_has_been_send: "Un nouveau courriel a été envoyé à votre adresse.",
    stop_working_with_fragmented_views: "Arrêtez de travailler avec des vues fragmentées.",
    gain_unified_donor_intelligence: "Obtenez une vision unifiée des donateurs et créez des propositions qui résonnent vraiment.",
    unlock_full_access_become_a_member: "Débloquez l'accès complet : Devenez membre.",
    see_how_it_works_schedule_a_free_tour: "Découvrez comment ça fonctionne : Planifiez une visite gratuite.",
    just_a_reminder: "Juste un rappel : Votre",
    discount_will_expire: "rabais expirera le",
    un_sdg_goals: "Vous avez un impact ? Les ODD de l'ONU sont des objectifs mondiaux pour un avenir meilleur (comme « Faim Zéro » ou « Action pour le climat »).",
    social_media: "Vous avez des réseaux sociaux ? Ajoutez les liens vers vos profils (comme Instagram, Facebook, X, LinkedIn) juste ici !",
    categories: "Sélectionnez les catégories qui décrivent le mieux la mission ou les domaines d'intervention de votre organisation.",
    geographic_areas_served: "Précisez les régions géographiques où votre organisation fournit des services ou un soutien.",
    populations_served: "Indiquez les principaux groupes ou communautés que votre organisation dessert.",
    mission: "De quoi parle votre organisation ? Partagez brièvement ici votre objectif principal ou votre mission fondamentale !",
    be_sure_creating_project_before_using_search_engine: "Assurez-vous de créer le projet avant d'utiliser le moteur de recherche.",
    assets_tooltip: "Total des actifs déclarés en fin d'année, tel qu'indiqué dans la série des formulaires 990 de l'IRS",
    revenue_tooltip: "Revenus annuels totaux enregistrés dans la série des formulaires 990 de l'IRS",
    donations_tooltip: "Total des contributions effectuées pendant l'année, selon la série des formulaires 990 de l'IRS",
    charities_helping_charities: "Programme de parrainage : Organismes aidant les organismes",
    refer_charity_earn_bonus: "Parrainez un organisme et gagnez du temps bonus !",
    refer_charity_line1: "Lorsque le premier organisme que vous parrainez s'inscrit à Grant Advance, vous recevrez un mois bonus.",
    refer_charity_line2: "Le deuxième parrainage vous donne deux mois bonus.",
    refer_charity_line3: "Le troisième et chaque parrainage supplémentaire vous donnent trois mois bonus chacun.",
    heads_up_irs_check_profile: "Attention ! L'IRS ne fournit pas de pièces jointes dans les données électroniques que nous utilisons ici. Cependant, vous en trouverez parfois dans la version PDF de la déclaration — consultez le profil !",
    heads_up_irs_check_below: "Attention ! L'IRS ne fournit pas de pièces jointes dans les données électroniques que nous utilisons ici. Cependant, vous trouverez parfois ces pièces jointes dans la version PDF de la déclaration — consultez ci-dessous !",
    remove_from_this_project: "Retire les bailleurs de fonds sélectionnés du projet actuel s'ils existent déjà dans les projets choisis, ce qui aide à éviter les doublons.",
    delete_selected_custom_document: "Cette action supprimera le document personnalisé pour les bailleurs de fonds sélectionnés.",
    delete_single_custom_document: "Cette action supprimera le document personnalisé pour ce bailleur de fonds.",
    recaptcha_loading: "Veuillez patienter pendant le chargement de la vérification de sécurité...",
    consent_to_allowing: "J'autorise Grant Advance à partager cette bonne nouvelle sur son site web, ses réseaux sociaux et d'autres plateformes",
    type_keyword: "Saisissez un mot-clé et appuyez sur Entrée pour ajouter une balise",
    add_alternatives_to_root_word: "Ajouter des alternatives au(x) mot(s) racine(s) dans votre recherche",
    view_and_manage_searches: "Voir et gérer vos résultats de recherche enregistrés et les informations de filtres sélectionnés pour référence future",
    load_saved_search: "Charger la recherche enregistrée",
    load_saved_search_description: "Le chargement d'une recherche enregistrée réinitialisera vos résultats de recherche actuels et les filtres avec ceux de la recherche enregistrée sélectionnée.",
    switch_search_type: "Changer le type de recherche",
    switch_search_type_description: "Changer le type de recherche effacera les filtres que vous avez appliqués ici. Voulez-vous continuer?",
    no_saved_search: "Aucune recherche enregistrée",
    coupon_textfield_placeholder: "Rechercher par code promo, nom ou créateur",
    no_results_found: "Aucun résultat trouvé",
    no_results_found_2: "Aucun résultat trouvé, essayez un autre mot-clé.",
    go_to_search_page: "Aller à la page de recherche",
    searching_for_funders: "Recherche de bailleurs de fonds",
    kindly_ensure_template_personalized: "Veuillez vous assurer que le modèle est personnalisé pour refléter votre propre voix et message. Nous ne recommandons pas de copier-coller la lettre directement. Puisqu'elle est accessible à tous nos membres, il est préférable de l'utiliser comme source d'inspiration pour créer votre propre version unique.",
    i_understand_deleting_this_master: "Je comprends que la suppression de ce document principal entraînera la suppression définitive de",
    customized_documents: "documents personnalisés",
    action_cannot_be_undone: "et cette action est irréversible",
    select_notification_date: "Sélectionnez la date à laquelle vous souhaitez être notifié",
    delete_this_alert: "Souhaitez-vous supprimer cette alerte ?",
    delete_this_note: "Souhaitez-vous supprimer cette note ?",
    update_funders_flag_status: "Cette action mettra à jour le statut du drapeau du bailleur de fonds",
    set_project_as_completed: "Marquer le projet {{projectName}} comme terminé ?",
    activate_project_confirm: "Activer « {{projectName}} » ? Cela le marquera comme actif et remettra le projet actif actuel en cours.",
    no_similar_charities_title: "Ajoutez D'abord des Organismes Similaires",
    no_similar_charities_confirm: "Ce projet n'a pas encore d'organismes similaires. Ajoutez-en pour lancer une Recherche par Pairs.",
    no_projects_yet_description: "Créez un projet pour commencer à trouver des bailleurs de fonds et générer des documents de subvention.",
    no_funders_in_project: "Il n'y a aucun bailleur de fonds dans votre projet",
    funders_currently_in_project_singular: "{{count}} bailleur de fonds actuellement dans votre projet",
    funders_currently_in_project_plural: "{{count}} bailleurs de fonds actuellement dans votre projet",
    qualified_funders_progress: "{{qualifiedCount}} sur {{fundersAmount}} qualifiés",    peer_search_info: "Cela utilisera la liste des organismes de bienfaisance similaires pour rechercher les bailleurs de fonds qui les ont soutenus.",
    qualifying_info: "La qualification consiste à examiner chaque bailleur de fonds de ce projet et à déterminer s’il correspond réellement — admissibilité, priorités de don et échéances — avant de lui écrire.",
    created_on_date: "Créé le : {{createdAt}}",
    ai_draft_recommended: "L'IA peut générer une solide première ébauche de ce document que vous pourrez réviser et personnaliser.",
    ai_beta_badge_tooltip: "Cette fonctionnalité d’IA est en version bêta. Les résultats peuvent être incomplets ou inexacts; veuillez donc les vérifier avant de vous y fier.",
    manual_draft_recommended: "Ce document est préférable de le rédiger manuellement.",
    status_flag_for: "Statut du drapeau pour {{foundationName}}",
    upload_document: "Téléversez tout type de document jusqu’à {{fileSize}} Mo",
    upload_document_up_to: "Téléversez jusqu’à {{fileCount}} fichiers à la fois, avec une taille maximale de {{fileSize}} Mo chacun. Types de fichiers pris en charge : Tous les fichiers",
    this_action_will_delete: "Cette action supprimera {{name}}",
    your_session_has_expired: "Votre session a expiré. Veuillez vous reconnecter.",
    your_account_without_permission: "Votre compte ne dispose pas des autorisations requises pour cette action.",
    congratulations_on_securing_funding: "Félicitations pour l'obtention de ce financement ! Faites fructifier cette réussite. Déclarez vos subventions et recevez 25 crédits bonus (d'une valeur de 25 $) pour chacune d'elles, échangeables contre des services qui permettront à votre organisation d'en faire encore plus:",
    select_one_or_more_subscription_plans: "Sélectionnez un ou plusieurs forfaits d’abonnement",
    action_50percent_discount: "Cette action donnera à ce coupon un rabais de plus de 50 %",
    token_copied_to_clipboard: "Jeton copié dans le presse-papiers",
    open_this_link_in_a_separated_browser: "Ouvrez ce lien dans un navigateur séparé ou une fenêtre de navigation privée pour découvrir la plateforme avec ce compte démo. Utilisez-le lors des appels avec des prospects pour parcourir les fonctionnalités sans avoir besoin de mot de passe.",
    do_not_share_with_customers: "Ne pas partager avec les clients · Ouvrir dans un navigateur séparé ou une fenêtre de navigation privée",
    resend_funder_alert_notifications: "Renvoyer les notifications d'alerte aux bailleurs de fonds",
    notifications_send_sucessfully: "{{count}} notification(s) envoyée(s) avec succès",
    enter_your_account_details: "Entrez les informations de votre compte pour vous connecter",
    having_trouble_signing_in: "Vous avez des difficultés à vous connecter ?",
    you_can_reset_password_here: "Vous pouvez réinitialiser votre mot de passe ici",
    kindly_enter_email_address: "Veuillez entrer l’adresse courriel utilisée lors de votre inscription. Nous vous enverrons un lien pour réinitialiser votre mot de passe.",
    kindly_enter_new_password: "Veuillez entrer votre nouveau mot de passe",
    password_must_contain: "Le mot de passe doit contenir",
    password_length_requirement: "Au moins 8 caractères",
    password_uppercase_requirement: "Au moins une lettre majuscule (A–Z)",
    password_lowercase_requirement: "Au moins une lettre minuscule (a–z)",
    password_number_requirement: "Au moins un chiffre (0–9)",
    password_special_character_requirement: "Au moins un caractère spécial (!@#$%^&* etc.)",
    notifications_send_sucessfully: "{{count}} notification(s) envoyée(s) avec succès",
    the_user_will_lose_access: "L'utilisateur perdra l'accès jusqu'à ce que la licence soit activée",
    suspend_the_license: "Suspendre cette licence ?",
    user_will_remain_active: "L'accès de l'utilisateur restera actif pendant l'activation de la licence",
    active_the_license: "Activer cette licence ?",
    activate_license: "Activer la licence",
    change_to_main_user: "Passer en utilisateur principal",
    remove_this_license: "Supprimer cette licence ?",
    you_are_about_to_remove_this_license: "Vous êtes sur le point de supprimer cette licence",
    change_the_main_user: "Changer l'utilisateur principal ?",
    this_updates_the_organization_master_account: "Cela met à jour le compte maître de l'organisation. L'action est appliquée immédiatement.",
    remove_email_notification: "Supprimer la notification par courriel",
    are_you_sure_remove_alert: "Êtes-vous sûr de vouloir supprimer cette notification par courriel?",
    opens_bambora_form: "Ouvre le formulaire Bambora - mise à niveau après approbation",
    mark_as_paid: "Marquer comme payé - mise à niveau directe",
    to_be_implemented: "À implémenter",
    upgrade_with_no_payment: "Mettre à niveau sans paiement",
    on_confirm_demo_data_message: "À la confirmation : les données de démonstration sont conservées, le statut est réinitialisé (la boîte de dialogue de bienvenue réapparaît) et l’e-mail de configuration est envoyé.",
    delete_this_qualification: "Êtes-vous sûr de vouloir supprimer cette qualification ?",
    funder_qualified_successfully: "Bailleur de fonds qualifié avec succès",
    last_qualified_for: "Dernière qualification pour",
    press_enter_enter_to_add_grant_type: "Appuyez sur Entrée pour ajouter un type de subvention",
    find_or_create_grant_type: "Rechercher ou créer un type de subvention",
    press_enter_to_add_sector: "Appuyez sur Entrée pour ajouter un secteur",
    find_or_create_sector: "Rechercher ou créer un secteur",
    select_at_least_one_sector: "Sélectionnez au moins un secteur",
    select_at_least_one_grant_type: "Sélectionnez au moins un type de subvention",
    ai_scan_database: "L’IA analyse la base de données et classe les bailleurs de fonds selon leur compatibilité avec le projet.",
    peer_search_no_ai: "Recherchez des bailleurs de fonds via des organismes semblables au vôtre — sans IA.",
    generate_full_loi: "Générez une lettre d’intérêt complète à partir des détails de votre projet en environ une minute.",
    grant_advance_ai_benefit: "Ces informations alimentent Grant Advance AI, qui les utilise pour générer des documents comme des lettres d’intérêt et des propositions, et pour trouver des bailleurs de fonds correspondant aux objectifs de votre projet.",
    grant_advance_ai_active: "Grant Advance AI utilise ces informations pour générer des documents comme des lettres d’intérêt et des propositions, et pour trouver des bailleurs de fonds correspondant aux objectifs de votre projet.",
    required_fields_legend: "* Champs obligatoires",
    fill_in_name_and_description: "Remplissez le Nom du projet et la Description ci-dessus, puis générez des suggestions de l’IA.",
    ready_to_generate_ai_suggestions: "Prêt à générer des suggestions de l’IA pour les Bénéficiaires cibles, les Mots-clés et les Preuves statistiques à partir des détails de votre projet.",
    statistical_proof_recommendation: "Nous recommandons d’ajouter jusqu’à 2 preuves statistiques, mais vous pouvez en ajouter autant que vous le souhaitez.",
    no_statistical_proof_suggestions: "Aucune suggestion disponible pour le moment. Essayez d’en rechercher d’autres.",
    some_steps_not_reviewed: "Vous n’avez pas révisé le contenu généré par l’IA aux étapes suivantes de votre lettre d’intérêt.",
    some_steps_not_completed: "Il semble que certaines étapes de ce module ne soient pas encore terminées. Continuez seulement si vous souhaitez les ignorer.",
    review_with_ai_powered: "Voulez-vous réviser et personnaliser ce document avec l’IA ?",
    ai_generated_content_please_review: "Contenu généré par l’IA — veuillez le réviser, le modifier au besoin et le confirmer.",
    overwrite_content_warning: "Lorsqu’activé, le contenu généré remplacera toutes les étapes existantes. Lorsqu’il est désactivé, le contenu sera généré uniquement pour les étapes vides.",
    gas_description: "Ajoutez les endroits où votre organisation intervient. Choisissez un pays entier, ou une {{orgRegion}} ou une ville dans {{orgCountry}}.",
    specific_area_description: "Les zones sont affichées pour {{orgCountry}}. Pour desservir un autre pays, ajoutez-le comme pays entier.",
    saved_search_loaded_main: "Recherche enregistrée chargée et appliquée",
    saved_search_loaded_result: "Recherche enregistrée chargée et appliquée",
    are_you_sure_you_want_proceed: "Êtes-vous sûr de vouloir continuer ?",
    review_with_ai: "Réviser avec l’IA",
    to_create_personalize_ai_doc: "Pour créer un document d’IA plus personnalisé, Grant Advance recommande de compléter toutes les étapes de votre {{docType}}.",
    funder_inactive: "Bailleur de fonds inactif depuis 3 ans ou plus. Aucune activité n’a été déclarée à l’IRS.",
    this_funder_has_supported: "Ce bailleur de fonds a soutenu {{count}} nouveaux bénéficiaires au cours des 3 dernières années.",
    you_have_an_existing_application: "Vous avez déjà une demande auprès de ce bailleur de fonds.",
  },
  user_menu: {
    profile: "Profil",
    logout: "Se déconnecter",
  },
  prompt: {
    areYouSure: "Êtes-vous sûr ?",
    confirmRemove: "Confirmer la suppression",
  },
  side_menu: {
    administration: "Administration",
    manage_account: "Gérer le compte",
    manage_announcement: "Annonces",
    manage_subscription_plan: "Formule d'abonnement",
    manage_coupons: "Coupons",
    manage_feedbacks: "Rétroactions",
    manage_deadlines: "Échéances",
    manage_smart_phrases: "Phrases intelligentes",
    manage_foundations: "Gérer les fondations",
    manage_plans: "Gérer les forfaits",
    account: "Compte",
    user_profile: "Profil de l'utilisateur",
    additional_users: "Utilisateurs supplémentaires",
    organization_profile: "Profil de l'organisation",
    project_manager: "Chef de projet",
    project_list: "Projets",
    project_archive: "Projets archivés",
    search_engine: "Moteur de recherche",
    search_engine_canada: "Moteur de recherche - CA (bêta)",
    by_giving_history: "Par historique de dons",
    by_name: "Par nom du bailleur de fonds",
    by_director: "Par les administrateurs",
    by_year: "Par année de création",
    by_deadline: "Par date limite",
    by_rating: "Par note",
    by_custom: "Par contacts privés",
    by_custom_profile: "Par profil personnalisé (Nouveau)",
    document_generator: "Générateur de documents",
    inquiry: "Demande de renseignements",
    proposal: "Proposition",
    budget: "Budget",
    custom_letter: "Lettre personnalisée",
    grant_secretary: "Secrétariat des subventions - Imprimer",
    manage_funders: "Gérer les bailleurs de fonds",
    favorites: "Favoris",
    blocked_funders: "Bloqués",
    custom_databases: "Bases de données personnalisées",
    by_keyword: "En donnant des intérêts",
    by_international_funding: "Financement international (PRO)",
    thank_you: "Remerciement",
    impact_report: "Rapport d'impact",
    previous: "Précédent",
    by_recipient_name: "Par nom du bénéficiaire",
    by_grant_purpose: "Par objectif de la subvention",
    by_funder_name: "Par nom du bailleur de fonds",
  },
  buttons: {
    done: "Terminé",
    create_account: "Créer un compte",
    send: "Envoyer",
    reset_password: "Réinitialiser le mot de passe",
    add_user: "Ajouter un utilisateur",
    insert_user: "Insérer un utilisateur",
    save_changes: "Enregistrer les modifications",
    update_profile: "Mettre à jour le profil",
    add_to_favorites: "Ajouter aux favoris",
    add_email: "Ajouter un courriel",
    select_header_file: "Sélectionner le fichier d'en-tête",
    select_footer_file: "Sélectionner le fichier de pied de page",
    update_account: "Mettre à jour le compte",
    more: "Plus",
    clear_search: "Effacer la recherche",
    search: "Rechercher",
    advanced_search: "Recherche avancée",
    create: "Créer",
    create_favorite_list: "Créer une liste de favoris",
    add: "Ajouter",
    confirm: "Confirmer",
    update: "Mettre à jour",
    confirm_delete: "Confirmer la suppression",
    confirm_remove: "Confirmer le retrait",
    next: "Suivant",
    prev: "Précéd.",
    add_funder: "Ajouter un bailleur de fonds",
    close: "Fermer",
    preview_document: "Aperçu du document",
    submit: "Soumettre",
    cancel: "Annuler",
    resend_email: "Renvoyer le courriel",
    confirm_purchase: "Confirmer l'achat",
    previous: "Précédent",
    watch_demo: "Regarder la démo",
    learn_more: "En savoir plus",
    filters: "Filtres",
    apply_filters: "Appliquer les filtres",
    clear_filters: "Effacer les filtres",
    select_states: "Sélectionner les États",
    select_provinces: "Sélectionner les provinces",
    select_counties: "Sélectionner les comtés",
    select_cities: "Sélectionner les villes",
    yes_load_search: "Oui, charger la recherche",
    no_keep_current_search: "Non, conserver la recherche actuelle",
    yes_switch_search_type: "Oui, changer",
    no_keep_current_filters: "Non, conserver les filtres",
    search_options: "Options de recherche",
    apply: "Appliquer",
    remove_flag: "Supprimer le drapeau",
    save: "Enregistrer",
    claim_my_credits: "Réclamez mes crédits",
    copy_and_close: "Copier et fermer",
    send_notifications: "Envoyer des notifications",
    try_again: "Réessayer",
    forgot_password: "Mot de passe oublié",
    no_keep_notification: "Non, conserver la notification",
    yes_remove: "Oui, supprimer",
    view_qualifications: "Voir les qualifications",
    add_new_qualification: "Ajouter une qualification",
    edit: "Modifier",
    delete: "Supprimer",
    qualify_funder: "Qualifier le bailleur de fonds",
    qualify_this_funder: "Qualifier ce bailleur de fonds",
    add_qualification: "Ajouter une qualification",
    yes_delete: "Oui, supprimer",
    no_keep_qualification: "Non, conserver la qualification",
    start_editing: "Commencer la modification",
    generate_with_ai: "Générer avec l’IA",
    create_manually: "Créer manuellement",
  },
  input_fields: {
    press_enter: "Appuyez sur Entrée pour ajouter des mots-clés",
  },
  tooltips: {
    to_country_filter: "Sélectionner un ou plusieurs pays désactivera le filtre par État",
    state_filter: "Sélectionner un ou plusieurs États désactivera le filtre par pays",
    county_filter: "Sélectionnez un État pour activer le filtre par comté. Désélectionnez toutes les villes pour activer le filtre par comté",
    city_filter: "Sélectionnez un État pour activer le filtre par ville. Désélectionnez tous les comtés pour activer le filtre par ville",
    custom_city_filter: "Sélectionnez un État pour activer le filtre par ville",
    cross_ref_location: "Lorsque la recherche par référence croisée est activée, l'État, le comté et la ville sélectionnés ici sont appliqués comme filtres supplémentaires en plus de vos termes de référence croisée — un don doit être destiné à cet endroit (et toujours correspondre à vos filtres de pays et d'année) pour être comptabilisé.",
    cross_ref_location_ca: "Lorsque la recherche par référence croisée est activée, la province et la ville sélectionnées ici sont appliquées comme filtres supplémentaires en plus de vos termes de référence croisée — un don doit être destiné à cet endroit (et toujours correspondre à vos filtres d'année et de secteur) pour être comptabilisé.",
    national_giving_interest_us_off: "Ajoute les bailleurs de fonds qui correspondent à vos termes de recherche et qui ont fait des dons dans au moins le nombre d'États sélectionné, même s'ils n'en ont pas fait dans l'État que vous avez choisi.",
    national_giving_interest_us_on: "Lorsque la Recherche croisée est activée, l'option Intérêt de dons national permet aux bailleurs de fonds qui donnent dans de nombreux endroits de correspondre quand même, même si le don en question n'a pas été fait dans l'État, le comté ou la ville sélectionnés, à condition qu'il corresponde toujours à vos termes de recherche, au pays, à l'année et au terme de recherche croisée lui-même.",
    national_giving_interest_ca_off: "Ajoute les bailleurs de fonds qui correspondent à vos termes de recherche et qui ont fait des dons dans au moins le nombre de provinces sélectionné, même s'ils n'en ont pas fait dans la province que vous avez choisie.",
    national_giving_interest_ca_on: "Lorsque la Recherche croisée est activée, l'option Intérêt de dons national permet aux bailleurs de fonds qui donnent dans de nombreux endroits de correspondre quand même, même si le don en question n'a pas été fait dans la province ou la ville sélectionnée, à condition qu'il corresponde toujours à vos termes de recherche, à l'année, au secteur et au terme de recherche croisée lui-même.",
    min_grants_to_state: "Nombre minimal de dons faits à des organismes dans chaque État sélectionné, sur l'ensemble de l'historique de dons disponible.",
    business_ein: "Besoin de mettre à jour votre EIN/BN ? Envoyez simplement un courriel à support@grantadvance.com avec les bonnes informations et notre équipe s'en occupera pour vous.",
    by_name: "Anciennement : Par nom",
    by_keyword: "Anciennement : Par mot-clé",
    by_year: "Anciennement : Par année",
    by_director: "Anciennement : Par directeur",
    by_custom: "Anciennement : Base de données personnalisée",
    target_beneficiaries: "Sélectionnez les groupes ou les personnes qui bénéficieront directement de ce projet.",
    create_project_keyword: "Ajoutez des mots-clés pertinents pour classer votre projet et en améliorer la visibilité.",
    similar_charities: "Recherchez des organismes de bienfaisance similaires à ce projet afin que nous puissions trouver des bailleurs de fonds qui soutiennent votre secteur.",
    other_funding_source: "Précisez toute source de financement supplémentaire contribuant à ce projet, en plus de la subvention principale.",
    statistical_proof: "Fournissez des données ou des preuves démontrant le besoin et l’impact prévu de votre projet.",
    grant_advance_ai: "Notre modèle d’IA utilise les détails de votre projet, comme les bénéficiaires ciblés, les mots-clés et les preuves statistiques. Vous pouvez également ajouter des informations personnalisées selon vos préférences.",
    by_giving_history_info: "Recherchez le nom d’un organisme de bienfaisance pour voir les fondations qui le financent.",
    by_keyword_info: "Recherchez par mots-clés pour voir les bailleurs de fonds ayant fait des dons à des organismes dont le nom ou la description contient vos termes (surlignés dans les résultats).",
    by_name_info: "Recherchez le nom complet d’un bailleur de fonds ou des mots-clés associés pour voir les profils correspondant à vos termes.",
    by_director_info: "Recherchez le nom d’un directeur pour trouver les bailleurs de fonds auxquels il est associé et consultez leurs profils pour voir les organismes qu’ils soutiennent.",
    by_year_info: "Sélectionnez une ou plusieurs années pour voir les bailleurs de fonds ayant versé des contributions durant ces années et consultez leurs profils pour voir les organismes qu’ils ont soutenus.",
    by_custom_info: "Utilisez la recherche personnalisée pour filtrer les résultats selon votre propre base de données.",
    by_international_info: "Recherchez dans nos bases de données mondiales pour trouver des fondations qui exercent leurs activités au-delà des frontières de votre pays.",
  },
  accountCreated: "Compte créé avec succès",
  accountDisabled: "Ce compte est désactivé. Pour plus de détails, contactez l'administrateur.",
  accountDisabledSuccess: "Compte désactivé avec succès",
  accountEnabledSuccess: "Compte activé avec succès",
  accountNotActivated: "Votre compte n'est pas actif. Veuillez vérifier votre courriel pour activer votre compte",
  accountUpdatedSuccess: "Compte mis à jour avec succès",
  additionalEmailNotFound: "Courriel supplémentaire introuvable",
  additionalEmailRemovedSuccess: "Courriel supplémentaire supprimé avec succès",
  additionalEmailSavedSuccess: "Courriel supplémentaire enregistré avec succès",
  additionalUserInsertSuccess: "Utilisateur supplémentaire ajouté avec succès",
  additionalUserUpdateSuccess: "Utilisateur supplémentaire mis à jour avec succès",
  additionalEmailLimit: "Vous pouvez ajouter jusqu'à {{limit}} adresses courriel supplémentaires seulement. Veuillez en supprimer une pour en ajouter une nouvelle.",
  additionalEmailLimitShort: "Vous pouvez ajouter jusqu'à {{limit}} adresses courriel supplémentaires seulement",
  addressBillingRequired: "L'adresse de facturation est obligatoire",
  alertNotificationSavedSuccess: "Notification d'alerte enregistrée avec succès",
  cityBillingRequired: "La ville de facturation est obligatoire",
  complementaryAddressBillingRequired: "L'adresse complémentaire de facturation est obligatoire",
  confirmRegisterUserSuccess: "Merci d'avoir confirmé votre courriel",
  countryBillingRequired: "Le pays de facturation est obligatoire",
  countryNotFound: "Pays introuvable",
  emailExists: "L'adresse courriel existe déjà",
  errorRegistration: "Le modèle est vide",
  expirationDateSavedSuccess: "Date d'expiration enregistrée avec succès",
  footerImageRequired: "L'image de pied de page est obligatoire",
  imageHeightLength: "Hauteur d'image invalide",
  imageWidthLength: "Largeur d'image invalide",
  invalidEmailAddress: "Adresse courriel invalide",
  invalidLetterType: "Type de lettre invalide",
  invalidPhoneNumber: "Numéro de téléphone invalide",
  invalidSubscriptionPlan: "Formule d'abonnement invalide",
  invalidUserRole: "Rôle d'utilisateur invalide",
  letterheadSavedSuccess: "En-tête enregistré avec succès",
  licenseExpired: "Votre licence a expiré. Pour plus de détails, veuillez contacter l'administrateur",
  licenseNotFound: "Aucune licence suffisante n'est disponible. Veuillez contacter support@grantadvance.com",
  loginFailed: "Nom d'utilisateur ou mot de passe invalide",
  masterOnly: "Seuls les utilisateurs principaux ont accès à cette ressource",
  notEnoughLicense: "Votre organisation n'a pas de licence disponible. Si vous souhaitez ajouter des licences, veuillez cliquer ici pour acheter des licences supplémentaires",
  notificationExists: "La notification existe déjà",
  notificationNotFound: "Notification introuvable",
  funderQualifiedSuccess: "Bailleur de fonds qualifié avec succès",
  funderResetSuccess: "Le bailleur de fonds a été réinitialisé avec succès",
  funderDisqualifiedSuccess: "Bailleur de fonds disqualifié avec succès",
  funderPausedSuccess: "Qualification du bailleur de fonds mise en pause avec succès",
  notificationTypeNotFound: "Type de notification introuvable",
  organizationDisabled: "Cette organisation est désactivée. Pour plus de détails, contactez l'administrateur.",
  organizationMainAddressUpdatedSuccess: "Adresse principale de l'organisation mise à jour avec succès",
  organizationNotFound: "Organisation introuvable",
  organizationProfileSavedSuccess: "Profil de l'organisation enregistré avec succès",
  passwordModified: "Mot de passe modifié avec succès",
  passwordRecovery: "Veuillez vérifier votre courriel pour réinitialiser votre mot de passe.",
  passwordReset: "Réinitialisation du mot de passe réussie",
  postalCodeBillingRequired: "Le code postal de facturation est obligatoire",
  profileNotFound: "Profil introuvable",
  provinceOrStateBillingRequired: "La province/l'état de facturation est obligatoire",
  help_center: "Centre d'aide",
  profile_settings: "Paramètres du profil",
  hi: "Bonjour",
  user_profile: "Profil utilisateur",
  logout: "Déconnexion",
  provinceOrStateNotFound: "État introuvable",
  sendActivationLinkSuccess: "Le courriel d'activation a été envoyé avec succès",
  sendPasswordResetSuccess: "Le courriel de réinitialisation du mot de passe a été envoyé avec succès",
  sendSetupPasswordSuccess: "Le courriel de configuration du mot de passe a été envoyé avec succès",
  separatedLicenceExpirationDateError: "La date d'expiration des licences séparées ne peut pas être supérieure à la date d'expiration de la licence principale",
  settingUpAccountSuccess: "Votre compte a été activé avec succès. Vous pouvez maintenant vous connecter",
  signatureSavedSuccess: "Signature enregistrée avec succès",
  subscriptionPlanNotFound: "Formule d'abonnement introuvable",
  userLogoutSuccess: "Déconnexion réussie",
  userNameExists: "Ce nom d'utilisateur est déjà pris",
  userNotAllowed: "L'utilisateur n'est pas autorisé à se connecter",
  userNotFound: "Utilisateur introuvable",
  userProfileSavedSuccess: "Profil utilisateur enregistré avec succès",
  wrongCurrentPassword: "Mot de passe actuel incorrect",
  additionalUsersRequired: "Les utilisateurs supplémentaires sont requis",
  addressRequired: "L'adresse est obligatoire",
  amountDaysRequired: "Le nombre de jours est obligatoire",
  amountLicensesRequired: "Le nombre de licences est requis",
  planAmountRequired: "Le montant du forfait est requis",
  amountMonthsRequired: "Le nombre de mois est requis",
  amountYearsRequired: "Le nombre d'années est requis",
  billingAddressLine2Required: "L'adresse complémentaire de facturation est obligatoire",
  billingAddressRequired: "L'adresse de facturation est obligatoire",
  billingCityRequired: "La ville de facturation est obligatoire",
  billingCountryRequired: "Le pays de facturation est obligatoire",
  billingPostalCodeRequired: "Le code postal de facturation est obligatoire",
  billingProvinceOrStateRequired: "La province/l'état de facturation est obligatoire",
  cityRequired: "La ville est obligatoire",
  companyNameRequired: "Le nom de l'entreprise est obligatoire",
  businessEinRequired: "Le BN/EIN est obligatoire",
  compareConfirmPassword: "Le mot de passe et le mot de passe de confirmation ne correspondent pas.",
  complementaryAddressRequired: "L'adresse complémentaire est obligatoire",
  confirmPasswordRequired: "Le mot de passe de confirmation est requis",
  countryRequired: "Le pays est requis",
  displayPlanRequired: "Le forfait d'affichage est obligatoire",
  emailRequired: "Le courriel est obligatoire",
  firstNameRequired: "Le prénom est obligatoire",
  headerImageRequired: "L'image d'en-tête est obligatoire",
  invalidEmail: "Cette adresse courriel est invalide",
  invalidRole: "Rôle d'utilisateur invalide",
  lastNameRequired: "Le nom de famille est obligatoire",
  licenseAmountRange: "Le nombre de licences doit être supérieur à zéro",
  licenseRequired: "La licence est obligatoire",
  newPasswordRequired: "Le nouveau mot de passe est requis",
  notificationTypeRequired: "Le type de notification est requis",
  oldPasswordRequired: "L'ancien mot de passe est requis",
  organizationIdRequired: "L'identifiant de l'organisation est requis",
  passwordLength: "Votre mot de passe doit contenir entre 6 et 20 caractères",
  passwordRequired: "Le mot de passe est obligatoire",
  phoneRequired: "Le numéro de téléphone est obligatoire",
  planDescriptionRequired: "La description du forfait est obligatoire",
  postalCodeRequired: "Le code postal est obligatoire",
  provinceOrStateRequired: "La province/l'état est obligatoire",
  roleRequired: "Le rôle est requis",
  signatureRequired: "La signature est obligatoire",
  subscriptionPlanNameRequired: "La formule d'abonnement est obligatoire",
  tokenRequired: "Le jeton est requis",
  userIdRequired: "L'identifiant utilisateur est requis",
  userNameRequired: "Le courriel de connexion est obligatoire",
  planNameRequired: "Le nom interne du forfait est requis",
  customLetterRequired: "La lettre personnalisée est obligatoire",
  customLetterSavedSuccess: "Lettre personnalisée enregistrée avec succès",
  customTagDeleteSuccess: "Balise personnalisée supprimée avec succès",
  customTagInsertSuccess: "Balise personnalisée créée avec succès",
  customTagNotFound: "Balise personnalisée introuvable",
  customTagUpdateSuccess: "Balise personnalisée mise à jour avec succès",
  documentStateInsertSuccess: "État du document créé avec succès",
  inquiryLetterRequired: "La lettre de demande est obligatoire",
  inquiryLetterSavedSuccess: "Lettre de demande enregistrée avec succès",
  proposalLetterRequired: "La lettre de proposition est obligatoire",
  proposalLetterSavedSuccess: "Lettre de proposition enregistrée avec succès",
  userProjectRequired: "Le projet utilisateur est obligatoire",
  customDocumentTypeRequired: "Le type de document est obligatoire",
  documentAmountRequired: "Le montant est requis",
  documentFlaggedRequired: "La date est obligatoire",
  documentStateRequired: "L'état du document est obligatoire",
  tagDescriptionRequired: "La description de la balise est obligatoire",
  tagNameRequired: "Le nom de la balise est obligatoire",
  blockedFundersDeleteAllSuccess: "Tous les bailleurs de fonds ont été débloqués avec succès",
  blockedFundersDeleteSuccess: "Bailleur de fonds débloqué avec succès",
  blockedFundersInsertSuccess: "Bailleur de fonds bloqué avec succès",
  blockedFundersNotFound: "Bailleur de fonds bloqué introuvable",
  customDatabaseDeleteSuccess: "Base de données personnalisée supprimée avec succès",
  customDatabaseFieldsMapRequired: "Veuillez configurer tous les champs obligatoires avant de continuer",
  customDatabaseNotFound: "Base de données personnalisée introuvable",
  customDatabaseUserFieldsEmpty: "La liste des champs de configuration est vide",
  favoriteDeleteSuccess: "Favori supprimé avec succès",
  favoriteDuplicateSuccess: "Favori dupliqué avec succès",
  favoriteFundersDeleteSuccess: "Bailleur de fonds favori supprimé avec succès",
  favoriteFundersInsertSuccess: "{{funders}} bailleurs de fonds ajoutés à {{favCount}} listes de favoris",
  favoriteFundersNotFound: "Bailleur de fonds favori introuvable",
  favoriteFundersUpdateSuccess: "Bailleur de fonds favori mis à jour avec succès",
  favoriteInsertSuccess: "Favori créé avec succès",
  favoriteNotFound: "Favori introuvable",
  favoriteUpdateSuccess: "Favori mis à jour avec succès",
  fundersListEmpty: "La liste des bailleurs de fonds est vide",
  noteDeleteSuccess: "Note supprimée avec succès",
  noteInsertSuccess: "Note créée avec succès",
  noteNotFound: "Note introuvable",
  noteUpdateSuccess: "Note mise à jour avec succès",
  noteRequired: "Une note est requise avant de joindre des documents",
  notificationDateRequired: "La date de notification est obligatoire",
  emailListRequired: "Sélectionnez le courriel",
  customDatabaseFileRequired: "Le fichier Excel est obligatoire",
  favoriteNameRequired: "Le nom du favori est requis",
  favoriteRequired: "Le favori est obligatoire",
  foundationRequired: "Le bailleur de fonds est obligatoire",
  jsonUserFieldsMapRequired: "Veuillez configurer tous les champs obligatoires avant de continuer",
  labelTypeRequired: "Le type d'étiquette est obligatoire",
  letterTypeRequired: "Sélectionnez le type de document à imprimer",
  noteDescriptionRequired: "La description est obligatoire",
  noteTitleRequired: "Le titre est obligatoire",
  bundleInsertSuccess: "Lot créé avec succès",
  bundleNotFound: "Lot introuvable",
  bundleTaskCount: "Entrez au moins une tâche",
  bundleTaskNotFound: "Une ou plusieurs tâches sont introuvables",
  flagDateRequired: "La date est obligatoire",
  flagUpdateSuccess: "Drapeau mis à jour avec succès",
  projectBudgetCategoryDescriptionRequired: "La description de la catégorie est obligatoire",
  projectBudgetDeleteSuccess: "Budget supprimé avec succès",
  projectBudgetDescriptionExists: "Cette description existe déjà",
  projectBudgetInsertSuccess: "Budget ajouté avec succès",
  projectBudgetNotFound: "Budget introuvable",
  projectBudgetResetSuccess: "Budget réinitialisé avec succès",
  projectBudgetUpdateSuccess: "Budget mis à jour avec succès",
  projectEndDateRequired: "La date de fin est obligatoire",
  projectFundersDeleteSuccess: "Bailleurs de fonds du projet supprimés avec succès",
  projectFundersEmpty: "Veuillez sélectionner au moins un bailleur de fonds avant de continuer",
  projectFundersInsertSuccess: "{{funderAmount}} bailleurs de fonds ajoutés à {{projectName}}",
  projectStartDateRequired: "La date de début est obligatoire",
  taskDeleteSuccess: "Tâche supprimée avec succès",
  taskEditSuccess: "Tâche mise à jour avec succès",
  taskInsertSuccess: "Tâche créée avec succès",
  taskListEmpty: "La liste des tâches est vide",
  taskNotFound: "Tâche introuvable",
  userProjectArchivedSuccess: "Projet utilisateur archivé avec succès",
  userProjectDeleteSuccess: "Projet utilisateur supprimé avec succès",
  userProjectEndDateRequired: "La date de fin est obligatoire",
  userProjectInsertSuccess: "Projet utilisateur créé avec succès",
  userProjectListEmpty: "Sélectionnez un ou plusieurs projets",
  userProjectNotFound: "Projet introuvable",
  userProjectStartDateInvalid: "La date de début est invalide",
  userProjectStartDateRequired: "La date de début est obligatoire",
  userProjectUnarchivedSuccess: "Projet utilisateur désarchivé avec succès",
  userProjectUpdateSuccess: "Projet utilisateur mis à jour avec succès",
  budgetTypeInvalid: "Le type de budget n'est pas valide",
  bundleDescriptionRequired: "La description du lot est obligatoire",
  bundleNameRequired: "Le nom du lot est requis",
  bundleTaskRequired: "La liste des tâches est obligatoire",
  flagAmountInvalid: "Le montant est invalide",
  flagAmountRequired: "Le montant est requis",
  flagStatusRequired: "Le statut est requis",
  foundationNameRequired: "Le nom du bailleur de fonds est obligatoire",
  foundationSourceTypeRequired: "La source du bailleur de fonds est obligatoire",
  profileIdRequired: "Le profil est obligatoire",
  projectBudgetAmountRequired: "Le montant du budget est requis",
  projectBudgetDescriptionRequired: "La description du budget est obligatoire",
  projectCostInvalid: "Le coût du projet est invalide",
  projectCostRequired: "Le coût du projet est obligatoire",
  projectDescriptionRequired: "La description du projet est obligatoire",
  projectNameRequired: "Le nom du projet est obligatoire",
  projectStatusInvalid: "Le statut du projet est invalide",
  taskDescriptionRequired: "La description de la tâche est obligatoire",
  taskNameRequired: "Le nom de la tâche est obligatoire",
  foundationInsertSuccess: "Bailleur de fonds ajouté avec succès",
  savedSearchDeleteSuccess: "Recherche supprimée avec succès",
  savedSearchDescriptionExists: "Cette description existe déjà",
  savedSearchInsertSuccess: "Recherche ajoutée avec succès",
  savedSearchNotFound: "Recherche enregistrée introuvable",
  savedSearchTypeInvalid: "Le type de recherche enregistré n'est pas valide",
  savedSearchUpdateSuccess: "Recherche mise à jour avec succès",
  descriptionRequired: "La description est obligatoire",
  jsonFieldsRequired: "Le champ de recherche est obligatoire",
  searchTypeRequired: "Le type de recherche est obligatoire",
  userProjectCompleted: "Ce projet est marqué comme terminé",
  sendOnlineApplicationSuccess: "Message de candidature en ligne envoyé avec succès",
  sendSuggestionSuccess: "Suggestion envoyée avec succès",
  urlRequired: "L'URL est obligatoire",
  fundersRemovedSuccess: "{{fundersRemoved}} bailleur(s) de fonds ont été retirés du projet actuel",
  noteSubjectRequired: "Le sujet est obligatoire",
  accountDeleted: "Ce compte a été supprimé. Contactez l'administrateur",
  userRemovedSuccess: "Compte supprimé avec succès",
  userNameOrEmailRequired: "Le nom d'utilisateur ou le courriel est obligatoire",
  fieldRequired: "Ce champ est obligatoire",
  pickupNewPassword: "Veuillez choisir un nouveau mot de passe",
  passwordMinCharacter: "Veuillez saisir au moins {{minimumCharaters}} caractères",
  enterSameValueAgain: "Veuillez saisir à nouveau la même valeur",
  feedbackSubmitted: "Commentaires soumis avec succès",
  feedbackInvalidGrantSize: "Le montant de la subvention n'est pas valide ou est trop important",
  feedbackReviewUpdated: "Avis mis à jour",
  announcementTitleRequired: "Le titre de l'annonce est obligatoire",
  announcementDescriptionRequired: "La description de l'annonce est obligatoire",
  announcementReleaseDateRequired: "La date de publication de l'annonce est requise",
  announcementReleaseDateInvalid: "Les dates passées ne sont pas autorisées pour la date de publication",
  announcementTypeRequired: "Le type d'annonce est obligatoire",
  announcementNotFound: "Annonce introuvable",
  announcementInsertSuccess: "Annonce ajoutée avec succès",
  announcementUpdateSuccess: "Annonce mise à jour avec succès",
  announcementDeleteSuccess: "Annonce supprimée avec succès",
  couponNameRequired: "Le nom du coupon est obligatoire",
  couponCodeRequired: "Le code promo est requis",
  couponCodeFormatInvalid: "Le code promo n'est pas valide",
  codeLengthInvalid: "Maximum de 15 caractères",
  couponExpirationDateRequired: "La date d'expiration du coupon est requise",
  couponExpirationMaxValue: "La date ne peut pas dépasser 6 mois à compter d'aujourd'hui",
  couponExpirationDateInvalid: "Date d'expiration invalide",
  couponSubscriptionPlanRequired: "La formule d'abonnement du coupon est requise",
  couponExtraMonthsAmountInvalid: "Le mois supplémentaire n'accepte que les nombres de 1 à 99",
  couponDiscountAmountInvalid: "Le rabais n'accepte que les nombres de 1 à 90",
  couponCodeAlreadyExist: "Le code promo a déjà été utilisé",
  couponSubscriptionNotFound: "Formule d'abonnement introuvable",
  couponNotFound: "Coupon introuvable",
  couponSelectType: "Veuillez sélectionner au moins un type de coupon (Temps supplémentaire/Rabais et/ou Déverrouillage de forfaits)",
  couponInsertSuccess: "Coupon ajouté avec succès",
  couponUpdateSuccess: "Coupon mis à jour avec succès",
  couponDeleteSuccess: "Coupon supprimé avec succès",
  couponPauseUpdateSuccess: "Coupon mis à jour avec succès",
  deadlineEINRequired: "L'EIN est requis",
  deadlineFoundationNameRequired: "Le nom du bailleur de fonds est obligatoire",
  deadlineCategoryRequired: "La catégorie est obligatoire",
  deadlineURLRequired: "L'URL de la date limite est requise",
  deadlineCountryRequired: "Le pays est requis",
  deadlineDateInvalid: "Seules les dates futures sont autorisées",
  deadlineAmountToobig: "Le montant de la subvention est trop élevé",
  deadlineImportSuccess: "{{fileName}} importé avec succès",
  deadlineImportSuccessWithWarning: "Le fichier a été importé avec succès. Cependant, certains éléments contiennent des données invalides. Veuillez les mettre à jour en conséquence",
  deadlineUpdateSuccess: "Date limite mise à jour avec succès",
  deadlineDeleteSuccess: "Date limite supprimée avec succès",
  deadlineRemovePopupMessage: "Cette action supprimera cette échéance",
  deadlineReviewCorrectInformation: "Veuillez vérifier et corriger les informations",
  deadlineInvalidFoundationDataField: "Les données fournies du bailleur de fonds contiennent une entrée invalide pour le champ {{invalidData}}.",
  deadlineInvalidFoundationDataFields: "Les données fournies du bailleur de fonds contiennent des entrées invalides pour les champs suivants : {{invalidData}}.",
  deadlineImportFilePrompt: "Voulez-vous importer ce fichier ?",
  thankYouLetterSavedSuccess: "Lettre de remerciement enregistrée avec succès",
  impactReportLetterSavedSuccess: "Lettre de rapport d'impact enregistrée avec succès",
  historyTypeRequired: "Le type d'historique est requis",
  startDateRequired: "La date de début est obligatoire",
  startDateInvalid: "Veuillez sélectionner une date postérieure à aujourd'hui",
  dateMin: "Veuillez sélectionner une date ultérieure à aujourd'hui",
  referralNameCharityRequired: "Le nom de l'organisme de bienfaisance est obligatoire",
  referralNameContactRequired: "Le nom du contact est obligatoire",
  referralSubmitted: "Parrainage soumis avec succès. Parrainer un autre organisme",
  templateApplying: "Application en cours, veuillez patienter...",
  templateApplyWarning: "L'application peut prendre quelques minutes",
  historyTimeline: {
    funderAdded: "Bailleur de fonds ajouté au projet",
    funderRemoved: "Bailleur de fonds retiré du projet",
    noteAdded: "Note ajoutée",
    foundationProfileView: "Profil du bailleur de fonds consulté sur le projet",
    customDoc: "Document personnalisé",
    masterDoc: "Document principal",
    createdOnProject: "créé dans le projet",
    deletedOnProject: "supprimé du projet",
    statusUpdated: "Statut mis à jour à",
    onProject: "dans le projet",
  },
  passwordNotMatch: "Le mot de passe que vous avez saisi ne correspond pas",
  emailAlreadyExist: "Cette adresse courriel est déjà enregistrée. Veuillez <a href='/' style='color: #02958a'>vous connecter</a>",
  licenseRenewSuccess: "Votre demande de renouvellement de licence a été envoyée avec succès. Notre équipe administrative la traitera prochainement.",
  grantAmountRequired: "Le montant de la subvention est requis",
  purposeRequired: "L'objectif est requis",
  dateAwardedRequired: "La date d'attribution est requise",
  shareConsentRequired: "Vous devez accepter les conditions requises pour continuer.",
  reportGrantSubmitted: "Votre rapport de subvention a été soumis avec succès",
  alertTitleRequired: "Le titre de l'alerte est requis",
  passwordInvalid: "Mot de passe incorrect, réessayez",
  allAssignedLicensesActive: "All assigned licenses are active",
  someAssignedLicensesNotActive: "Some assigned licenses are not active",
  switchMainUserLicenseSuccess: "La licence de l'utilisateur principal a été transférée avec succès.",
  allAssignedLicensesActive: "Toutes les licences attribuées sont actives",
  someAssignedLicensesNotActive: "Certaines licences attribuées ne sont pas actives",
  switchMainUserLicenseSuccess: "La licence de l'utilisateur principal a été changée avec succès.",
  licenseDeletedSuccessfuly: "Licence supprimée avec succès",
  errorDeletingLicense: "Erreur lors de la suppression de la licence",
  upgradeDemoAccountSuccess: "La mise à niveau du compte démo a été effectuée avec succès",
  skipPaymentReasonRequired: "The reason is required",
  funderQualificationInsertSuccess: "Qualification du bailleur de fonds ajoutée avec succès",
  funderQualificationUpdateSuccess: "Qualification du bailleur de fonds mise à jour avec succès",
  funderQualificationDeleteSuccess: "Qualification du bailleur de fonds supprimée avec succès",
  sectorInsertSuccess: "Secteur ajouté avec succès",
  grantTypeInsertSuccess: "Type de subvention ajouté avec succès",
  stepStatusUpdated: "Statut de révision mis à jour avec succès",
};